module.exports = __webpack_public_path__ + "img/400(3).13ef1d2e.svg";